module.exports = __webpack_public_path__ + "static/media/file.399adc62.svg";